module.exports = __webpack_public_path__ + "img/tip.1320da65.png";